import { ComponentPropsWithoutRef, SVGProps } from 'react'
import { cn } from '~shared/utils/cn'
import Image from 'next/image'
import { replacePrepositionsWhitespaces } from '~shared/utils/replace-prepositions-whitespaces'

const WhyUsCard = ({
  className,
  index,
  title,
  label,
  children,
  ...rest
}: {
  index?: string
  title?: string
  label?: string
} & ComponentPropsWithoutRef<'li'>) => {
  return (
    <li
      className={cn('relative rounded-[24px] overflow-hidden', className)}
      {...rest}>
      {children}
      <span className='absolute top-card-inner-indent left-card-inner-indent text-[14px] md:text-[16px] leading-[1.1]'>
        {index}
      </span>
      <div className='absolute inset-card-inner-indent top-auto'>
        <p className='atext-[14px] md:text-[20px] xl:text-[24px] font-medium tracking-[-0.16px]'>
          {replacePrepositionsWhitespaces(title)}
        </p>
        <p className='mt-[16px] leading-[1.1]'>{label}</p>
      </div>
    </li>
  )
}

export interface WhyUsSectionProps
  extends ComponentPropsWithoutRef<'section'> {}

export const WhyUsSection = (props: WhyUsSectionProps) => {
  const { className = '', ...rest } = props

  return (
    <section className={cn('container container-slim', className)} {...rest}>
      <h2 className='typo-section-heading text-center'>
        Обучение в «Московском институте технологий и управления» — это
      </h2>
      <ul
        className={cn(
          'xl:pb-[150px]',
          'mt-[30px] md:mt-[24px] lg:mt-[40px] xl:mt-[60px]',
          'grid grid-cols-2 grid-rows-[174px_90px_174px_174px] gap-[10px]',
          'md:grid-cols-2 md:grid-rows-[204px_120px_120px_204px] md:gap-4',
          'lg:grid-cols-6 lg:grid-rows-[220px_143px_220px]',
          'xl:grid-cols-4 xl:grid-rows-[300px_300px]',
          '2xl:grid-rows-[372px_372px]'
        )}>
        <WhyUsCard
          index='01.'
          title='Интерактивная платформа'
          label='доступ к видео-лекциям и конспектам 24/7 с любого утсройства'
          className='bg-secondary lg:col-span-2 xl:col-span-1 translate-y-0 xl:translate-y-[45px]'
        />
        <WhyUsCard className='bg-tertiary lg:col-span-2 xl:col-span-1 translate-y-0 xl:translate-y-[150px]' />
        <WhyUsCard
          index='02.'
          title='Возможность вернуть 13% от стоимости обучения'
          label='Предоставляем всем студентам возможность налогового вычета'
          className='lg:col-span-2 xl:col-span-1 bg-secondary'
        />
        <WhyUsCard
          index='03.'
          title='Лекционные и практические задания'
          label='по отработке техник'
          className='bg-[#9071F5] text-primary lg:col-span-3 xl:col-span-1 translate-y-0 xl:translate-y-[68px]'
        />
        <WhyUsCard
          index='04.'
          title='Поддержка куратора 24/7'
          label='обмен опытом, поддержка и рост профессионализма на супервизиях'
          className='bg-[#9071F5] text-primary lg:col-span-3 xl:col-span-1 translate-y-0 xl:translate-y-[45px]'
        />
        <WhyUsCard
          index='05.'
          title='Дистанционное обучение'
          label='в комфортном для вас темпе из любой точки мира'
          className='bg-secondary lg:col-span-2 xl:col-span-1 translate-y-0 xl:translate-y-[150px]'
        />
        <WhyUsCard className='lg:col-span-2 xl:col-span-1 bg-tertiary' />
        <WhyUsCard
          index='06.'
          title='Работа в мини-группах'
          label='под руководством опытных психологов для отработки психологических техник и получения обратной связи'
          className='bg-secondary lg:col-span-2 xl:col-span-1 translate-y-0 xl:translate-y-[68px]'
        />
      </ul>
    </section>
  )
}
